export default __webpack_public_path__ + "static/media/Oracle-linux.c2b6ad69.png";